import NotificationFormInterface from "@app/Interface/NotificationFormInterface";

export default class NotificationFormModel implements NotificationFormInterface {
    
    enableNotifications: boolean;
    sendEmailNotifications: boolean;
    notificationEmailAddress: string;
    sendSmsNotifications: boolean;
    notificationPhoneNumber: string;

    constructor() {
        this.enableNotifications = false;
        this.sendEmailNotifications = false;
        this.notificationEmailAddress = "";
        this.sendSmsNotifications = false;
        this.notificationPhoneNumber = "";
    }

}